const popupContentComponent = (editor, componentOpts) => {
  const dc = editor.DomComponents;

  const popupComponentOptions = componentOpts["popup-content"];
  const {
    name,
    type,
    mainAttribute,
  } = popupComponentOptions;

  const popupCloseStyles = componentOpts["popup-close"].style;

  const traitOpts = [
    {
      type: "text",
      name: "id",
      label: "ID",
      placeholder: "Enter id...",
    },
  ];

  dc.addType(type, {
    isComponent: (el) =>
      el.tagName === "DIV" &&
      el.getAttribute(mainAttribute) === type,

    model: {
      defaults: {
        tagName: "div",
        draggable: true,
        droppable: true,
        attributes: {
          [mainAttribute]: type,
          "data-gjs-type": type,
          "data-gjs-name": name,
        },
        // style: style,
        traits: traitOpts,
        components: [
          {
            type: "popup-close",
            style: popupCloseStyles
          }
        ]
      },
    },
  });
};

export default popupContentComponent;
